import { blocksToPlainText } from './emailTemplateBlocks.js';
import { templateHasWeakPlaceholders } from './templateBlueprint.js';
const TAG_RE = /^[a-z][a-z0-9_]*:[a-z0-9_-]+$/i;
export function normalizeTemplateTags(raw) {
    const out = [];
    const seen = new Set();
    for (const t of raw ?? []) {
        const s = t.trim().toLowerCase();
        if (!s || !TAG_RE.test(s))
            continue;
        if (seen.has(s))
            continue;
        seen.add(s);
        out.push(s);
    }
    return out.sort();
}
export function parseTagsInput(input) {
    return normalizeTemplateTags(input
        .split(/[,;\n]+/)
        .map((s) => s.trim())
        .filter(Boolean));
}
export function formatTagsForInput(tags) {
    return normalizeTemplateTags(tags).join(', ');
}
const MOTION_BY_CATEGORY = {
    cold_outreach: 'motion:cold',
    backlink: 'motion:backlink',
    partnership: 'motion:partnership',
    broadcast: 'motion:broadcast',
};
export function suggestedDefaultTags(category, touch = 'touch-1') {
    return normalizeTemplateTags([
        `fase:${touch}`,
        MOTION_BY_CATEGORY[category] ?? `motion:${category.replace(/_/g, '-')}`,
        'taal:nl',
    ]);
}
const UNSUB_RE = /\b(afmelden|uitschrijven|unsubscribe|abmelden|opt[- ]?out|klik hier om te stoppen)\b/i;
export function validateTemplateGovernance(input) {
    const blockers = [];
    const warnings = [];
    const subject = input.subject.trim();
    const name = input.name.trim();
    if (templateHasWeakPlaceholders({ subject, blocks: input.blocks, body_text: input.body_text })) {
        blockers.push('Geen "…" of "..." in naam, onderwerp of body.');
    }
    if (/[A-Z]{6,}/.test(subject.replace(/\{\{[^}]+\}\}/g, ''))) {
        blockers.push('Onderwerp: vermijd ALL CAPS (spam-signaal).');
    }
    const personal = subject.includes('{{voornaam}}') ||
        subject.includes('{{company}}') ||
        subject.includes('{{first_name}}');
    if (!personal && subject.length < 12) {
        warnings.push('Onderwerp: voeg {{voornaam}} of {{company}} toe voor personalisatie.');
    }
    let bodyText = input.body_text ?? '';
    if (input.blocks?.length) {
        try {
            bodyText = blocksToPlainText(input.blocks);
        }
        catch {
            bodyText = input.body_text ?? '';
        }
    }
    if (UNSUB_RE.test(bodyText)) {
        blockers.push('Geen afmeld-/unsubscribe-tekst in de body — de worker voegt footer automatisch toe.');
    }
    const hasCtaBlock = input.blocks?.some((b) => b.type === 'cta') ?? false;
    const hasQuestion = /\?/.test(bodyText) || /\?/.test(subject);
    if (!hasCtaBlock && !hasQuestion && input.render_mode !== 'html') {
        warnings.push('Voeg één duidelijke vraag (?) of een CTA-knop toe.');
    }
    if (name.length > 120) {
        warnings.push('Interne naam is erg lang — prospects zien alleen onderwerp/body.');
    }
    if (/\btemplate\s*[-—]/i.test(name) && name.length > 60) {
        warnings.push('Interne naam lijkt op export-titel; houd het kort en herkenbaar.');
    }
    return { ok: blockers.length === 0, blockers, warnings };
}
/** Zet plain-text template om naar blokken (legacy TEXT → blocks). */
export function legacyTextToBlocks(bodyText) {
    const chunks = bodyText
        .split(/\n{2,}/)
        .map((p) => p.trim())
        .filter(Boolean);
    if (!chunks.length) {
        return [{ type: 'paragraph', text: bodyText.trim() || ' ' }];
    }
    return chunks.map((text) => ({ type: 'paragraph', text }));
}
//# sourceMappingURL=templateGovernance.js.map